import { createRouter } from '@rune-ts/server';
import { errorSuspendStoreRouter } from '@services/MarppleShop/renderApp/pages/ErrorSuspendStore/ErrorSuspendStoreRoute.ts';
import { searchResultCreatorShopRouter } from '@services/MarppleShop/renderApp/pages/SearchResultCreatorShop/SearchResultCreatorShop.route.ts';
import { creatorRoute } from '../../pages/Creator/Creator.route';
import { creatorShopMembershipRouter } from '../../pages/CreatorShopMembership/CreatorShopMembershipRoute';
import { creatorShopMembershipPaymentRouter } from '../../pages/CreatorShopMembershipPayment/CreatorShopMembershipPaymentRoute';
import { creatorShopMembershipProductListRouter } from '../../pages/CreatorShopMembershipProductList/CreatorShopMembershipProductListRoute';
import { creatorViewDetailRouter } from '../../pages/CreatorViewDetail/CreatorViewDetail.route';
import { errorRouter } from '../../pages/Error/ErrorRoute';
import { marppleshopAppLinkRouter } from '../../pages/MarppleshopAppLink/MarppleshopAppLinkRoute';
import { plusShopCreatorRouter } from '../../pages/PlusShopCreator/PlusShopCreatorRoute';
import { creatorViewListRouter } from '../../pages/CreatorViewList/CreatorViewList.route';
import { curationDetailRouter } from '../../pages/CurationDetail/CurationDetail.route';
import { curationListRouter } from '../../pages/CurationList/CurationList.route';
import { mainRouter } from '../../pages/Main/mainRouter';
import { photoReviewRouter } from '../../pages/PhotoReview/photoReviewRouter';
import { plusContentRouter } from '../../pages/PlusContentList/PlusContentList.route';
import { plusShopProductListRouter } from '../../pages/PlusShopProductList/PlusShopProductList.route';
import { productListRouter } from '../../pages/ProductList/ProductList.route';
import { searchResultRouter } from '../../pages/SearchResult/SearchResult.route';
import { allCreatorsRouter } from '../../pages/AllCreators/AllCreatorsRoute';
import { popupStoreListRouter } from '../../pages/PopupStoreList/PopupStoreListRoute';
import { popupStoreDetailRouter } from '../../pages/PopupStoreDetail/PopupStoreDetailRoute';
import { verifyEmailRouter } from '../../pages/VerifyEmail/VerifyEmailRoute';
import { allPlusShopRouter } from '../../pages/AllPlusShop/AllPlusShopRoute';
import { bestProductRouter } from '../../pages/ProductRanking/bestProductRouter';
import { todayContentLegacyRouter } from '../../pages/TodayContentLegacy/TodayContentLegacyRoute';
import { specificCommerceLawsRouter } from '../../pages/SpecificCommerceLaws/SpecificCommerceLawsRoute';
import { authRouter } from '../../pages/Authorization/LoginRoute';
import { popupStoreLandingRouter } from '../../pages/PopupStoreLanding/PopupStoreLanding.route';
import { plusShopLandingRouter } from '../../pages/PlusShopLanding/PlusShopLanding.route';
import { handmadeCreatorLandingRouter } from '../../pages/HandmadeCreatorLanding/HandmadeCreatorLandingRoute';
import { adResRouter } from '../../pages/AdRes/AdResRoute';
import { adResAdRouter } from '../../pages/AdResAd/AdResAdRoute';
import { adResFinishRouter } from '../../pages/AdResFinish/AdResFinishRoute';
import { recentlySoldRouter } from '../../pages/RecentlySold/RecentlySoldRoute';
import { membershipReceiptRouter } from '../../pages/MembershipReceipt/MembershipReceiptRoute';
import { recentlyRouter } from '../../pages/MyPage/Recently/Recently.route';
import { receiptViewerRouter } from '../../pages/ReceiptViewer/ReceiptViewerRoute';
import { myMembershipRouter } from '../../pages/MyPage/Membership/Membership.route';
import { commerceCreatorLandingRouter } from '../../pages/CommerceCreatorLanding/CommerceCreatorLandingRoute';
import { creatorShopFanLetterRouter } from '../../pages/CreatorShopFanLetter/CreatorShopFanLetterRoute';
import { goodsPartnerLandingRouter } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/GoodsPartnerLandingRoute.ts';

type RouterType = typeof mainRouter &
  typeof productListRouter &
  typeof recentlySoldRouter &
  // typeof productDetailRouter &
  typeof authRouter &
  typeof photoReviewRouter &
  typeof plusContentRouter &
  typeof curationListRouter &
  typeof plusShopCreatorRouter &
  typeof mainRouter &
  typeof curationDetailRouter &
  typeof creatorViewDetailRouter &
  typeof creatorViewListRouter &
  typeof searchResultRouter &
  typeof popupStoreListRouter &
  typeof popupStoreDetailRouter &
  typeof plusShopProductListRouter &
  typeof creatorRoute &
  typeof allCreatorsRouter &
  typeof allPlusShopRouter &
  typeof verifyEmailRouter &
  typeof bestProductRouter &
  typeof todayContentLegacyRouter &
  typeof errorRouter &
  typeof specificCommerceLawsRouter &
  typeof popupStoreLandingRouter &
  typeof plusShopLandingRouter &
  typeof handmadeCreatorLandingRouter &
  typeof adResRouter &
  typeof adResAdRouter &
  typeof adResFinishRouter &
  typeof creatorShopMembershipRouter &
  typeof creatorShopMembershipPaymentRouter &
  typeof creatorShopMembershipProductListRouter &
  typeof marppleshopAppLinkRouter &
  typeof membershipReceiptRouter &
  typeof recentlyRouter &
  typeof receiptViewerRouter &
  typeof myMembershipRouter &
  typeof receiptViewerRouter &
  typeof commerceCreatorLandingRouter &
  typeof creatorShopFanLetterRouter &
  typeof searchResultCreatorShopRouter &
  typeof errorSuspendStoreRouter &
  typeof goodsPartnerLandingRouter;

export const ClientRouter = createRouter<RouterType>({
  ...productListRouter,
  ...recentlySoldRouter,
  // ...productDetailRouter,
  ...authRouter,
  ...photoReviewRouter,
  ...plusContentRouter,
  ...curationListRouter,
  ...plusShopCreatorRouter,
  ...mainRouter,
  ...curationDetailRouter,
  ...creatorViewDetailRouter,
  ...creatorViewListRouter,
  ...searchResultRouter,
  ...popupStoreListRouter,
  ...popupStoreDetailRouter,
  ...plusShopProductListRouter,
  ...creatorRoute,
  ...allCreatorsRouter,
  ...allPlusShopRouter,
  ...verifyEmailRouter,
  ...bestProductRouter,
  ...todayContentLegacyRouter,
  ...specificCommerceLawsRouter,
  ...errorRouter,
  ...popupStoreLandingRouter,
  ...plusShopLandingRouter,
  ...handmadeCreatorLandingRouter,
  ...adResRouter,
  ...adResAdRouter,
  ...adResFinishRouter,
  ...creatorShopMembershipRouter,
  ...creatorShopMembershipPaymentRouter,
  ...creatorShopMembershipProductListRouter,
  ...marppleshopAppLinkRouter,
  ...membershipReceiptRouter,
  ...recentlyRouter,
  ...receiptViewerRouter,
  ...myMembershipRouter,
  ...commerceCreatorLandingRouter,
  ...creatorShopFanLetterRouter,
  ...searchResultCreatorShopRouter,
  ...errorSuspendStoreRouter,
  ...goodsPartnerLandingRouter,
});
